/**
 * Non-default language URL prefixes used by Kirby multilang.
 * Default language (nl) uses the site root without a prefix.
 */
const LANGUAGE_PREFIXES = ["en", "fr"];

export function getLanguagePrefix(pathname = window.location.pathname) {
  const first = pathname.split("/").filter(Boolean)[0];
  return LANGUAGE_PREFIXES.includes(first) ? first : "";
}

export function languageAwareUrl(path) {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  const prefix = getLanguagePrefix();

  if (!prefix) {
    return `${window.location.origin}${normalized}`;
  }

  if (normalized === "/") {
    return `${window.location.origin}/${prefix}`;
  }

  return `${window.location.origin}/${prefix}${normalized}`;
}

export function projectsIndexUrl() {
  const fromDom = document.body?.dataset?.projectsUrl;
  if (fromDom) {
    return fromDom;
  }
  return languageAwareUrl("/projects");
}

export function newsIndexUrl(hash = "") {
  const fromDom = document.body?.dataset?.newsUrl;
  const base = fromDom || languageAwareUrl("/news");
  return hash ? `${base}#${hash}` : base;
}
